import { getRouteBasePath } from "app/tools/common"

export const CAMPAIGN_ID_PATH_PARAM: string = ":campaignId"
export const MEDIA_ID_PATH_PARAM: string = ":mediaId"
export const REPORTS_ID_PATH_PARAM: string = ":reportId"
export const SETTINGS_PAGE_ID_PARAM: string = ":pageId"
export const ADVERTISER_ID_PATH_PARAM: string = ":advertiserId"

export const CAMPAIGN_TAB_ID_QUERY_PARAM: string = "tabId"

export const LOGIN_PATH: string = `${getRouteBasePath()}/login`
export const SIGNUP_PATH: string = `${getRouteBasePath()}/signup`
export const SIGNUP_VERIFICATION_PATH: string = `${getRouteBasePath()}/signup-verification`
export const HOME_PATH: string = `${getRouteBasePath()}/`
export const DASHBOARD_PATH: string = `${getRouteBasePath()}/dashboard`
export const MY_CAMPAIGNS_PATH: string = `${getRouteBasePath()}/my-campaigns`
export const CAMPAIGN_CREATE_PATH: string = `${getRouteBasePath()}/create-campaign`
export const CAMPAIGN_EDIT_PATH: string = `${getRouteBasePath()}/edit-campaign/${CAMPAIGN_ID_PATH_PARAM}`
export const CAMPAIGN_SUMMARY_PATH: string = `${getRouteBasePath()}/campaign-summary/${CAMPAIGN_ID_PATH_PARAM}`
export const MY_FORECASTS_PATH: string = `${getRouteBasePath()}/my-forecasts`
export const FORECAST_CREATE_PATH: string = `${getRouteBasePath()}/create-forecast`
export const FORECAST_EDIT_PATH: string = `${getRouteBasePath()}/edit-forecast/${CAMPAIGN_ID_PATH_PARAM}`
export const FORECAST_SUMMARY_PATH: string = `${getRouteBasePath()}/forecast-summary/${CAMPAIGN_ID_PATH_PARAM}`
export const CAMPAIGN_MEDIA_PATH: string = `${getRouteBasePath()}/campaign-media/${CAMPAIGN_ID_PATH_PARAM}/${MEDIA_ID_PATH_PARAM}`
export const NOT_FOUND_PATH: string = `${getRouteBasePath()}/404`
export const ADVERTISERS_PATH: string = `${getRouteBasePath()}/advertisers`
export const ADVERTISER_CREATE_PATH: string = `${getRouteBasePath()}/advertiser`
export const ADVERTISER_UPDATE_PATH: string = `${getRouteBasePath()}/advertiser/${ADVERTISER_ID_PATH_PARAM}`
export const ORDERS_PATH: string = `${getRouteBasePath()}/orders`
export const ADMIN_UI_CONFIG_PATH: string = `${getRouteBasePath()}/admin/ui-configuration`
export const REPORTS_CREATE_PATH: string = `${getRouteBasePath()}/create-reports`
export const REPORTS_MY_PATH: string = `${getRouteBasePath()}/my-reports`
export const REPORTS_EDIT_PATH: string = `${getRouteBasePath()}/reports/${REPORTS_ID_PATH_PARAM}`
export const SETTINGS_PATH: string = `${getRouteBasePath()}/settings/${SETTINGS_PAGE_ID_PARAM}`
export const FORGOT_PASSWORD_PATH: string = `${getRouteBasePath()}/forgot-password`
export const RESET_PASSWORD_PATH: string = `${getRouteBasePath()}/reset-password`
export const MY_SSP_DEALS_PATH: string = `${getRouteBasePath()}/my-dsp-deals`
export const DSP_DEAL_CREATE_PATH: string = `${getRouteBasePath()}/create-dsp-deal`
export const DSP_DEAL_EDIT_PATH: string = `${getRouteBasePath()}/edit-dsp-deal/${CAMPAIGN_ID_PATH_PARAM}`
export const DSP_DEAL_SUMMARY_PATH: string = `${getRouteBasePath()}/dsp-deal-summary/${CAMPAIGN_ID_PATH_PARAM}`
export const SSP_MEDIA_APPROVALS_PATH: string = `${getRouteBasePath()}/ssp-media-approvals`
export const REVENUE_PATH: string = `${getRouteBasePath()}/revenue`

export interface IPage {
  path: string // must starts with "/"
  params?: string[]
  jsxElement: any
  usedForEverybody?: boolean
  usedForAdminOnly?: boolean
  disabled?: boolean
  notLogguedAvailability?: boolean
  confirmLeaving?: () => string | undefined // return an error message that said why we'll not leave the page
}

export interface IPageService {
  getAll(): IPage[]
  getActive(): IPage
  getByPath(pagePath: string): IPage
  existByPath(pagePath: string): boolean
}

export interface IPageState {
  pages: IPage[]
  activePage: IPage
}

export interface IPageServiceState {
  allPages: IPage[]
}
